import useFetch from 'src/hook/api/useFetch';
import useProgress from 'src/hook/data/useProgress';
import useUser from 'src/hook/data/useUser';
import usePopUp from 'src/hook/modal/usePopUp';
import { HttpMethod, ResponseType } from 'src/model/enum/enums';
import { GetCertificateUrl, ImageLocation } from 'src/utils/URLUtils';
import styles from './CertificatePopUp.module.scss';


const CertificatePopUp = () => {
    const { hide } = usePopUp();
    const { saveProgress } = useProgress();
    const { send } = useFetch();
    const { userInfo } = useUser();


    const handleApply = async () => {
        const { response } = await send(`${GetCertificateUrl()}/GetId/${userInfo?.UserId}`,
            HttpMethod.GET,{},
            ResponseType.Text);
        if (!response) return;
        saveProgress({
            Action: 'Certificate',
            Value: 'yes'
        });
        hide();
        window.open(`${GetCertificateUrl()}/${response}/me`, '_blank');
    };

    return (
        <div className={styles.certificatePopUp}>
            <h1>Get your Certificate</h1>
            <p>
                100% Free for the first 100 users.
                <br />
                (normal cost: $39)
            </p>
            <img src={ImageLocation('Lexi/certificate.png')} alt="Certificate" className={styles.image} />
            <button onClick={handleApply}>Apply Now</button>
        </div>
    );
};

export default CertificatePopUp;